import { isChatLoadingState } from '@widgets/messenger/types/chat/chat'
import translateService from '@widgets/shared/services/translate/translateService'
import { useWidgetAlerts } from '@widgets/messenger/compositions/useWidgetAlerts'
import { useChatStore } from '@widgets/messenger/stores/useChatStore'
import { useWidgetChatInit } from '@widgets/messenger/compositions/useWidgetChatInit'
import { useWidgetNavigation } from '@widgets/messenger/compositions/useWidgetNavigation'
import type { MessengerAlertScope } from '@widgets/messenger/types/alert'
import { watchEffect } from '@/composition/vue/compositionApi'

const scope: MessengerAlertScope = 'chatConnection'
const somethingWentWrongAlertId = 'chatSomethingWentWrong'
const noInternetConnectionAlertId = 'chatNoInternetConnection'

export const useWidgetChatConnectionAlerts = () => {
  const { addAlert, removeAlert } = useWidgetAlerts([scope])
  const { isConnected, chatState } = useChatStore()
  const { reInitChat } = useWidgetChatInit()
  const { goToMainView } = useWidgetNavigation()

  const onRefresh = async () => {
    const result = await reInitChat()
    if (result === false) {
      goToMainView()
    }
  }

  const initConnectionAlerts = () => {
    watchEffect(() => {
      if (isChatLoadingState(chatState.value) && chatState.value.error) {
        addAlert({
          id: somethingWentWrongAlertId,
          text: translateService.t('common.somethingWentWrong'),
          scope,
          onRefresh,
        })
      } else {
        removeAlert(somethingWentWrongAlertId)
      }
      if (!isConnected.value) {
        addAlert({
          id: noInternetConnectionAlertId,
          text: translateService.t('common.noInternetConnection'),
          scope,
          onRefresh,
        })
      } else {
        removeAlert(noInternetConnectionAlertId)
      }
    })
  }

  return {
    initConnectionAlerts,
  }
}
